
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Sports() {
  const [data, setData] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchData = async (url) => {
    try {
      setLoading(true);
      const res = await fetch(url);
      const json = await res.json();
      const articles = json.data || [];

      setData(articles);
      setNextUrl(json.pagination?.next_page_url);
      setPrevUrl(json.pagination?.prev_page_url);
    } catch (err) {
      console.error("فشل في جلب أخبار الرياضة:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData("https://ppmn.net/dash/api/Get/CategoryArticles/sport-news");
  }, []);

  if (loading) {
    return <div className="loader">جاري تحميل أخبار الرياضة...</div>;
  }

  return (
    <div className="container my-5">
      <div className="section-header mb-4">رياضة</div>
      <div className="row">
        {data.map((item) => (
          <div
            className="col-xl-3 col-lg-4 col-md-6 mb-4"
            key={item.article_id}
          >
            <div
              className="card card-custom h-100"
              onClick={() =>
                navigate(`/News/sport-news/${item.article_id}/${item.article_slug}`)
              }
              style={{ cursor: "pointer" }}
            >
              <div style={{ position: "relative" }}>
                <img
                  src={item.article_title_image}
                  alt={item.article_title}
                  className="card-img-top"
                  loading="lazy"
                />
              </div>
              <div className="card-body">
                <h6 className="card-title">{item.article_title}</h6>
              </div>
              <div className="publish-time-left text-black-50">
                {item.article_published_before || "بدون تاريخ"}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="pagination-buttons d-flex justify-content-center gap-3 mt-4">
        <button
          className="btn btn-outline-secondary"
          onClick={() => fetchData(prevUrl)}
          disabled={!prevUrl}
        >
          الصفحة السابقة
        </button>
        <button
          className="btn btn-outline-secondary"
          onClick={() => fetchData(nextUrl)}
          disabled={!nextUrl}
        >
          الصفحة التالية
        </button>
      </div>
    </div>
  );
}
